import { render, staticRenderFns } from "./preview-email.vue?vue&type=template&id=b5c3952a"
import script from "./preview-email.vue?vue&type=script&lang=js"
export * from "./preview-email.vue?vue&type=script&lang=js"
import style0 from "./preview-email.vue?vue&type=style&index=0&id=b5c3952a&prod&lang=css"
import style1 from "./preview-email.vue?vue&type=style&index=1&id=b5c3952a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports